export default {"src":"/_next/static/media/ecommerce-tech.87b88d03.svg","height":45,"width":161,"blurWidth":0,"blurHeight":0};